import { render, staticRenderFns } from "./CategoriesListTable.vue?vue&type=template&id=4aa0b019"
import script from "./CategoriesListTable.vue?vue&type=script&lang=js"
export * from "./CategoriesListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports